import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { editCustomRecords } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function updateCustomRecords({
  params,
  accountId,
  lookupId,
  recordId,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    editCustomRecords(accountId, lookupId, recordId),
    {
      method: 'PUT',
      headers: {
        Authorization: getTokenWithType(),
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        ...params,
      }),
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  params: any;
  accountId: number;
  lookupId: string;
  recordId: string;
};

type TSnapshot = unknown;

function useUpdateCustomRecords(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ params, accountId, lookupId, recordId }: TVariables) => {
      const newRecord = await updateCustomRecords({
        params,
        accountId,
        lookupId,
        recordId,
      });
      if (newRecord.Errors) throw newRecord;
      else if (newRecord.Data) {
        queryClient.invalidateQueries(['custom_records']);
        queryClient.invalidateQueries(['get_custom_table']);
      }
      return newRecord;
    },
  );
}

export { useUpdateCustomRecords };
